import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { MeasuresTableComponent } from "../measures-table/measures-table.component";
import { AsyncPipe, CommonModule } from '@angular/common';

import { FormsModule} from '@angular/forms';
import { MatExpansionModule} from '@angular/material/expansion';
import { MeasureComponentsComponent } from "../measure-components/measure-components.component";
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';

import { ReactiveFormsModule } from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';
import { CdkDragDrop, CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { Store } from '@ngrx/store';
import * as fromMeasures from '@store/selectors/measures/measures.selectors';
import { ICriteria } from '@models/measures.model';
import { MeasuresActions } from '@store/actions/measures/measures.actions';
import { IDropdown } from '@models/dropdown.model';

import { ConnectFormDirective } from '@directives/connect-form/connect-form.directive';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-measures',
  imports: [
    CommonModule,
    MeasuresTableComponent,
    FormsModule,
    MatExpansionModule,
    MeasureComponentsComponent,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    CdkDropList, 
    CdkDrag,
    ConnectFormDirective,
    AsyncPipe
],
  templateUrl: './measures.component.html',
  styleUrl: './measures.component.css'
})
export class MeasuresComponent implements OnInit, OnDestroy {

  private readonly store = inject(Store);
  private subscription: Subscription = new Subscription();

  showMeasureDetails$ = this.store.select<boolean>(fromMeasures.showMeasureDetails);
  typesList$ = this.store.select<IDropdown[]>(fromMeasures.selectMeasureTypeList);
  measureDetail$ = this.store.select<ICriteria[]>(fromMeasures.selectCriteriaList) || [];
  canAddCriteria$  = this.store.select<boolean>(fromMeasures.canAddCriteria);
  form$ = this.store.select(fromMeasures.selectCurrentMeasureEdit);

  measuresForm = new FormGroup({
    title: new FormControl(''),
    description: new FormControl(''),
    eMeasure_Measure_identifier: new FormControl(''),
    qpP_identifier: new FormControl(),
    measureTypeID: new FormControl(),
    highPriority: new FormControl(),
  });

  constructor(){    
    this.subscription.add(
      this.measuresForm.get('title')?.valueChanges.subscribe((value) => {
        if (value !== null) {
          this.store.dispatch(MeasuresActions.updateMeasureTitle({ title: value }));
        }
      })
    )
    
    this.subscription.add(
      this.measuresForm.get('description')?.valueChanges.subscribe((value) => {
        if (value !== null) {
          this.store.dispatch(MeasuresActions.updateMeasureDescription({ description: value }));
        }
      })
    )
    
    this.subscription.add(
      this.measuresForm.get('eMeasure_Measure_identifier')?.valueChanges.subscribe((value) => {
        if (value !== null) {
          this.store.dispatch(MeasuresActions.updateMeasureEcqm({  ecqm: value  }));
        }
      })
    )
    
    this.subscription.add(
      this.measuresForm.get('qpP_identifier')?.valueChanges.subscribe((value) => {
        if (value !== null) {
          this.store.dispatch(MeasuresActions.updateMeasureQpp({ qpp: value }));
        }
      })
    )
    
    this.subscription.add(
      this.measuresForm.get('measureTypeID')?.valueChanges.subscribe((value) => {
        this.store.dispatch(MeasuresActions.updateMeasureType({ measureType: value }));
      })
    )
    
    this.subscription.add(
      this.measuresForm.get('highPriority')?.valueChanges.subscribe((value) => {
        this.store.dispatch(MeasuresActions.updateMeasurePriority({ priority: value }));
      })
    )    
  };

  ngOnInit(): void {
    this.store.dispatch(MeasuresActions.measuresComponentLoaded());
  }
 
  saveMeasureData(){
    this.store.dispatch(MeasuresActions.clickSaveMeasure());
  }

  drop(event: CdkDragDrop<number[]>) {
    this.store.dispatch(MeasuresActions.reorderCriteriaList( { previous: event.previousIndex, current: event.currentIndex }));
  }

  addNewPopulation(){
    this.store.dispatch(MeasuresActions.clickAddNewCriteria())   
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
